// Barcode search on the pack screen (2026-10-26): pure helpers.
//
// The packer taps the magnifier, then types part of a barcode or scans it;
// matching lines move to the top of the list in yellow with the matching
// characters marked. A search box, not a scan: any part of the code
// matches and letter case is ignored. Packing still compares exactly.
import { scannableBarcodes } from "./itemBarcodes";

type Searchable = { sku: string; barcode: string; barcodes?: string[] };

/** Where the query was found: the code it is in and the span to mark. */
export type SearchHit = { field: "barcode" | "sku"; value: string; start: number; end: number };

/** The first of the line's barcodes, then its SKU, that contains `query`. */
export const findSearchHit = (item: Searchable, query: string): SearchHit | null => {
    const needle = query.trim().toLowerCase();
    if (!needle) return null;
    for (const code of scannableBarcodes(item)) {
        const at = code.toLowerCase().indexOf(needle);
        if (at >= 0) return { field: "barcode", value: code, start: at, end: at + needle.length };
    }
    const at = item.sku.toLowerCase().indexOf(needle);
    return at >= 0 ? { field: "sku", value: item.sku, start: at, end: at + needle.length } : null;
};

/** Matching lines first; each group keeps the order it already had. */
export const hitsFirst = <T>(items: readonly T[], isHit: (item: T) => boolean): T[] => [
    ...items.filter(isHit),
    ...items.filter(item => !isHit(item)),
];
